// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScreenAnalyticsPage {
  padding-left: 281px;
  background: #eff0f4;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
}
.ScreenAnalyticsPage__titleBlock {
  width: 100%;
  background: #fff;
  padding: 43px 40px 27px;
  box-sizing: border-box;
}
.ScreenAnalyticsPage__title {
  font-family: "Montserrat Regular", sans-serif;
  font-weight: 500;
  font-size: 24px;
  line-height: 1.2;
  color: #1a193c;
}
.ScreenAnalyticsPage__content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px 40px 48px;
  box-sizing: border-box;
}
.ScreenAnalyticsPage__filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
}
.ScreenAnalyticsPage__kpiRow {
  margin: 0 !important;
}
.ScreenAnalyticsPage__kpiCard {
  height: 100%;
  border-radius: 8px;
}
.ScreenAnalyticsPage__kpiCard .ant-card-body {
  padding: 20px 24px;
}
.ScreenAnalyticsPage__kpiValue {
  margin: 8px 0 0 !important;
  font-family: "Montserrat Regular", sans-serif;
}
.ScreenAnalyticsPage__sectionCard {
  border-radius: 8px;
}
.ScreenAnalyticsPage__sectionCard .ant-card-head {
  padding: 16px 24px;
  min-height: auto;
}
.ScreenAnalyticsPage__sectionCard .ant-card-body {
  padding: 20px 24px 24px;
}
.ScreenAnalyticsPage__bottomRow {
  margin: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/ScreenAnalyticsPage/ScreenAnalyticsPage.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;AACF;AACE;EACE,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;AACJ;AAEE;EACE,6CAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,sBAAA;AADJ;AAIE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;AAFJ;AAKE;EACE,oBAAA;AAHJ;AAME;EACE,YAAA;EACA,kBAAA;AAJJ;AAMI;EACE,kBAAA;AAJN;AAQE;EACE,0BAAA;EACA,6CAAA;AANJ;AASE;EACE,kBAAA;AAPJ;AASI;EACE,kBAAA;EACA,gBAAA;AAPN;AAUI;EACE,uBAAA;AARN;AAYE;EACE,oBAAA;AAVJ","sourcesContent":[".ScreenAnalyticsPage {\n  padding-left: 281px;\n  background: #eff0f4;\n  width: 100%;\n  min-height: 100vh;\n  box-sizing: border-box;\n\n  &__titleBlock {\n    width: 100%;\n    background: #fff;\n    padding: 43px 40px 27px;\n    box-sizing: border-box;\n  }\n\n  &__title {\n    font-family: 'Montserrat Regular', sans-serif;\n    font-weight: 500;\n    font-size: 24px;\n    line-height: 1.2;\n    color: #1a193c;\n  }\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    padding: 32px 40px 48px;\n    box-sizing: border-box;\n  }\n\n  &__filters {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 16px;\n  }\n\n  &__kpiRow {\n    margin: 0 !important;\n  }\n\n  &__kpiCard {\n    height: 100%;\n    border-radius: 8px;\n\n    .ant-card-body {\n      padding: 20px 24px;\n    }\n  }\n\n  &__kpiValue {\n    margin: 8px 0 0 !important;\n    font-family: 'Montserrat Regular', sans-serif;\n  }\n\n  &__sectionCard {\n    border-radius: 8px;\n\n    .ant-card-head {\n      padding: 16px 24px;\n      min-height: auto;\n    }\n\n    .ant-card-body {\n      padding: 20px 24px 24px;\n    }\n  }\n\n  &__bottomRow {\n    margin: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ScreenAnalyticsPage": `ScreenAnalyticsPage`,
	"ScreenAnalyticsPage__titleBlock": `ScreenAnalyticsPage__titleBlock`,
	"ScreenAnalyticsPage__title": `ScreenAnalyticsPage__title`,
	"ScreenAnalyticsPage__content": `ScreenAnalyticsPage__content`,
	"ScreenAnalyticsPage__filters": `ScreenAnalyticsPage__filters`,
	"ScreenAnalyticsPage__kpiRow": `ScreenAnalyticsPage__kpiRow`,
	"ScreenAnalyticsPage__kpiCard": `ScreenAnalyticsPage__kpiCard`,
	"ant-card-body": `ant-card-body`,
	"ScreenAnalyticsPage__kpiValue": `ScreenAnalyticsPage__kpiValue`,
	"ScreenAnalyticsPage__sectionCard": `ScreenAnalyticsPage__sectionCard`,
	"ant-card-head": `ant-card-head`,
	"ScreenAnalyticsPage__bottomRow": `ScreenAnalyticsPage__bottomRow`
};
export default ___CSS_LOADER_EXPORT___;
